module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"paymentType":{"label":"Payment Type","creditCard":"Credit Card","account":"Account Code"},"accountCode":{"label":"Account Code","placeholder":"Existing Account Code"},"creditCard":{"number":{"label":"Credit Card","placeholder":"Card #"},"expiration":{"label":"Expiration","month":{"placeholder":"Month","jan":"January","feb":"February","mar":"March","apr":"April","may":"May","jun":"June","jul":"July","aug":"August","sep":"September","oct":"October","nov":"November","dec":"December"},"year":{"placeholder":"Year"}},"code":{"label":"CVC","placeholder":"CVC"}}}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Payment.vue
// module id = 169
// module chunks = 1